interface Update {
  date: string;
  tag: string;
  title: string;
}

const updates: Update[] = [
  { date: '07-31', tag: '上线', title: '《暗夜追踪》第12集更新，大结局即将揭晓' },
  { date: '07-30', tag: '新增', title: '院线大片《逆光前行》高清版已上线' },
  { date: '07-30', tag: '修复', title: '部分用户播放卡顿问题已优化解决' },
  { date: '07-29', tag: '上线', title: '《长安风云录》第三季第8集同步更新' },
  { date: '07-29', tag: '新增', title: '科幻巨制《星际迷航：新纪元》全网首播' },
  { date: '07-28', tag: '上线', title: '口碑佳作《小镇故事》温情上线，评分9.0' },
  { date: '07-28', tag: '维护', title: '服务器升级完成，播放流畅度提升30%' },
  { date: '07-27', tag: '新增', title: '新增多部高分纪录片，涵盖自然、人文主题' },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-[800px] mx-auto">
          <div className="mb-8 md:mb-10">
            <h2 className="font-heading text-2xl md:text-3xl text-foreground-950">最新动态</h2>
            <p className="text-sm text-foreground-600 mt-1">内容更新 · 系统维护 · 功能公告</p>
          </div>

          <div className="relative">
            <div className="absolute left-[19px] top-0 bottom-0 w-px bg-background-300"></div>
            <div className="space-y-5">
              {updates.map((u, i) => (
                <div key={i} className="relative flex items-start gap-4 pl-12">
                  <div className={`absolute left-[12px] w-4 h-4 rounded-full border-2 ${
                    u.tag === '上线' || u.tag === '新增'
                      ? 'border-primary-500 bg-primary-500/20'
                      : u.tag === '修复' || u.tag === '维护'
                      ? 'border-secondary-500 bg-secondary-500/20'
                      : 'border-foreground-400 bg-background-100'
                  }`}></div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                      <span className="text-xs text-foreground-600 whitespace-nowrap">{u.date}</span>
                      <span className={`px-1.5 py-0.5 rounded text-[10px] font-medium whitespace-nowrap ${
                        u.tag === '上线' || u.tag === '新增'
                          ? 'bg-primary-500/15 text-primary-500'
                          : u.tag === '修复' || u.tag === '维护'
                          ? 'bg-secondary-500/15 text-secondary-500'
                          : 'bg-foreground-200/10 text-foreground-600'
                      }`}>
                        {u.tag}
                      </span>
                    </div>
                    <p className="text-sm text-foreground-700 mt-1">{u.title}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}